import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2} from '@angular/core';
import {BooleanControl, ButtonControl, UIArtefakt} from '../../../models/uiArtefakt';
import {ButtonCommandService} from '../../../services/button-command.service';
import {UIAusrichtung} from '../../../models/uiAusrichtung';
import {Dokument} from '../../../models/dokument';
import {map, switchMap} from 'rxjs/operators';
import {EventService} from '../../../services/event.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {ErrorService} from '@lv1871/core';
import {ShellConfigService} from '../../../services/shell-config.service';
import {UIArtefaktTyp} from '../../../models/uiArtefaktTyp';
import {UIDarstellungsart} from '../../../models/uiDarstellungsart';

@Component({
    selector: 'lv-download-button-mit-vorschau',
    templateUrl: './download-button-mit-vorschau.component.html',
    styleUrls: ['./download-button-mit-vorschau.component.scss'],
    standalone: false
})
export class DownloadButtonMitVorschauComponent implements OnInit, AfterViewInit  {
  public uiAusrichtung: UIAusrichtung;
  public downloadVerpflichtend: boolean = false;
  public dokumenteState$: Observable<Dokument[]>;
  private _uiArtefakt: ButtonControl;
  private _dokumente: Dokument[];
  private _selectAllDokuments: boolean;
  private _successfullyDownloaded: boolean;
  private _currentCheckboxWerteingabe: boolean;

  constructor(private _shellConfigService: ShellConfigService,
              private _commandService: ButtonCommandService, public eventService: EventService, private _errorService: ErrorService,
              private _renderer: Renderer2, private _element: ElementRef) {
  }

  get uiArtefakt(): ButtonControl {
    return this._uiArtefakt;
  }

  @Input()
  set uiArtefakt(uiArtefakt: ButtonControl) {
    this._uiArtefakt = uiArtefakt;
    if (this.downloadVerpflichtend) {
      const checkbox = this._getBooleanControls()[0] as BooleanControl;
      if (this._successfullyDownloaded) {
        if (this._currentCheckboxWerteingabe === checkbox.WertEingabe) {
          this._successfullyDownloaded = false;
          checkbox.WertEingabe = null;
          checkbox.Darstellungsart = UIDarstellungsart.DISABLED;
          checkbox.recreateComponent = true;
        } else {
          checkbox.Darstellungsart = UIDarstellungsart.OHNE_EINSCHRAENKUNGEN;
        }
      }
      this._currentCheckboxWerteingabe = checkbox.WertEingabe;
    }
  }

  ngAfterViewInit(): void {
    this._renderer.setAttribute(this._element.nativeElement, 'cypress-uuid', this.uiArtefakt.IdentifikatorUuid);
    if(!!this.uiArtefakt.ReferenzIdentifikator) {
      this._renderer.setAttribute(this._element.nativeElement, 'cypress-refId', this.uiArtefakt.ReferenzIdentifikator);
    }
  }

  ngOnInit(): void {
    this._validateChildren();
    this.uiAusrichtung = this._shellConfigService.getParameter().uiAusrichtung;
    this.downloadVerpflichtend = (this.uiArtefakt.ButtonComponent === 'DownloadVerpflichtendMitVorschau');
    this._selectAllDokuments = true;
    this.dokumenteState$ = this.eventService.uiControls$.pipe(
        switchMap(_ => this._commandService.handleLoadDokumentPaketCommand(this.uiArtefakt)),
        map(dokumentPaket => {
          dokumentPaket.forEach(dokumentNeu => {
            if (this.downloadVerpflichtend || this._selectAllDokuments) {
              dokumentNeu.selected = true;
            } else {
              const altesDokument = this._dokumente?.filter(dokument => dokument.BeschreibungKurz === dokumentNeu.BeschreibungKurz)[0];
              if (!!altesDokument) {
                dokumentNeu.selected = altesDokument.selected;
              } else {
                dokumentNeu.selected = true;
              }
            }
          });
          this._dokumente = dokumentPaket;
          this._selectAllDokuments = false;
          return dokumentPaket;
        })
    );
  }

  public enableCheckbox() {
    if (this.downloadVerpflichtend) {
      this._validateChildren();
      const checkbox = this._getBooleanControls()[0] as BooleanControl;
      this._successfullyDownloaded = true;
      checkbox.Darstellungsart = UIDarstellungsart.OHNE_EINSCHRAENKUNGEN;
      checkbox.recreateComponent = true;
    }
  }

  receiveDocumentsFromTree(dokument: Dokument[]) {

    const dokSubject: BehaviorSubject<Dokument[]> = new BehaviorSubject<Dokument[]>([]);
    dokSubject.next(dokument);

    this.dokumenteState$ = dokSubject.asObservable();

  }

  public selectToggle() {
    this._dokumente.forEach(dokument => {
      dokument.selected = true;
    });
  }

  public unselectToggle() {
    this._dokumente.forEach(dokument => {
      dokument.selected = false;
    });
  }

  private _validateChildren(): void {
    if (this.downloadVerpflichtend) {
      if (this._getBooleanControls().length !== 1) {
        this._errorService.pushErrorMessage('In einer DownloadButtonMitVorschauComponent muß genau eine ' +
            'PflichtCheckbox zur Lesebestätigung liegen (Zwangsdownload).');
      }
    }
  }

  private _getBooleanControls(): UIArtefakt[] {
    return this.uiArtefakt.UIArtefakt.filter(artefakt => artefakt.UIArtefakttyp === UIArtefaktTyp.BOOLEAN &&
        (artefakt as BooleanControl).BooleanComponent === 'PflichtCheckbox');
  }

}
